import { render, staticRenderFns } from "./item-details.vue?vue&type=template&id=3299f9ec&scoped=true"
import script from "./item-details.vue?vue&type=script&lang=js"
export * from "./item-details.vue?vue&type=script&lang=js"
import style0 from "./item-details.vue?vue&type=style&index=0&id=3299f9ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3299f9ec",
  null
  
)

export default component.exports